import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
const handleFetchCompanies = async () => {
  const uri = `v1/companies`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateCompany = async (data: any) => {
  const uri = `v1/companies`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateCompany = async ({ data, _id }: any) => {
  const uri = `v1/companies/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteCompany = async ({ _id }: any) => {
  const uri = `v1/companies/${_id}`;
  const response = deleteData({ uri });
  return response;
};

export {
  handleFetchCompanies,
  handleCreateCompany,
  handleUpdateCompany,
  handleDeleteCompany,
};
